"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _types = require("./types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducerActions = (state, action) => {
  switch (action.type) {
    case _types.BLOCK_CURRENT_SET:
      return _objectSpread({}, state, {
        currentBlock: action.payload
      });

    case _types.PROVIDER_SET:
      return _objectSpread({}, state, {
        provider: action.payload
      });

    case _types.PROVIDER_SET_MULTIPLE:
      return _objectSpread({}, state, {
        providers: action.payload
      });

    case _types.PROVIDER_SET_STATUS:
      return _objectSpread({}, state, {
        providerStatus: action.payload
      });

    case _types.SET_ADDRESS:
      return _objectSpread({}, state, {
        address: action.payload
      });

    case _types.BALANCE_SET:
      return _objectSpread({}, state, {
        balance: action.payload
      });

    case _types.NONCE_SET:
      return _objectSpread({}, state, {
        nonce: action.payload
      });

    case _types.NETWORK_SET:
      return _objectSpread({}, state, {
        network: action.payload
      });

    case _types.ENS_ADDRESS_SET:
      return _objectSpread({}, state, {
        ensAddress: action.payload
      });

    default:
      return state;
  }
};

var _default = reducerActions;
exports.default = _default;